import { render, staticRenderFns } from "./ShowAllNotifications.vue?vue&type=template&id=2b18a1cb&scoped=true"
import script from "./ShowAllNotifications.vue?vue&type=script&lang=js"
export * from "./ShowAllNotifications.vue?vue&type=script&lang=js"
import style0 from "./ShowAllNotifications.vue?vue&type=style&index=0&id=2b18a1cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b18a1cb",
  null
  
)

export default component.exports